/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Components_Performancetable_Topposition2Inputs */

const id_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const ms_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atas ${i?.position}`)
};

const da_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const de_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const en_us2_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const es_es2_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const es_mx2_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const fil_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nangungunang ${i?.position}`)
};

const fr_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const it_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const hu_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const nl_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const no_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Topp ${i?.position}`)
};

const pl_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pozycja ${i?.position}`)
};

const pt_br2_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const pt_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const ro_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const fi_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const sv_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Topp ${i?.position}`)
};

const vi_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Top ${i?.position}`)
};

const tr_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`İlk ${i?.position}`)
};

const cs_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nejlepší ${i?.position}`)
};

const bg_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Топ ${i?.position}`)
};

const ru_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Топ ${i?.position}`)
};

const uk_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Топ ${i?.position}`)
};

const ar_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أعلى ${i?.position}`)
};

const hi_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शीर्ष ${i?.position}`)
};

const th_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อันดับ ${i?.position}`)
};

const ja_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トップ${i?.position}`)
};

const zh_cn2_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 ${i?.position}`)
};

const zh_hant1_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 ${i?.position} 名`)
};

const ko_components_performancetable_topposition2 = /** @type {(inputs: Components_Performancetable_Topposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}위`)
};

/**
* | output |
* | --- |
* | "Top {position}" |
*
* @param {Components_Performancetable_Topposition2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_topposition2 = /** @type {((inputs: Components_Performancetable_Topposition2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Topposition2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_topposition2(inputs)
	if (locale === "ms") return ms_components_performancetable_topposition2(inputs)
	if (locale === "da") return da_components_performancetable_topposition2(inputs)
	if (locale === "de") return de_components_performancetable_topposition2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_topposition2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_topposition2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_topposition2(inputs)
	if (locale === "fil") return fil_components_performancetable_topposition2(inputs)
	if (locale === "fr") return fr_components_performancetable_topposition2(inputs)
	if (locale === "it") return it_components_performancetable_topposition2(inputs)
	if (locale === "hu") return hu_components_performancetable_topposition2(inputs)
	if (locale === "nl") return nl_components_performancetable_topposition2(inputs)
	if (locale === "no") return no_components_performancetable_topposition2(inputs)
	if (locale === "pl") return pl_components_performancetable_topposition2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_topposition2(inputs)
	if (locale === "pt") return pt_components_performancetable_topposition2(inputs)
	if (locale === "ro") return ro_components_performancetable_topposition2(inputs)
	if (locale === "fi") return fi_components_performancetable_topposition2(inputs)
	if (locale === "sv") return sv_components_performancetable_topposition2(inputs)
	if (locale === "vi") return vi_components_performancetable_topposition2(inputs)
	if (locale === "tr") return tr_components_performancetable_topposition2(inputs)
	if (locale === "cs") return cs_components_performancetable_topposition2(inputs)
	if (locale === "bg") return bg_components_performancetable_topposition2(inputs)
	if (locale === "ru") return ru_components_performancetable_topposition2(inputs)
	if (locale === "uk") return uk_components_performancetable_topposition2(inputs)
	if (locale === "ar") return ar_components_performancetable_topposition2(inputs)
	if (locale === "hi") return hi_components_performancetable_topposition2(inputs)
	if (locale === "th") return th_components_performancetable_topposition2(inputs)
	if (locale === "ja") return ja_components_performancetable_topposition2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_topposition2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_topposition2(inputs)
	return ko_components_performancetable_topposition2(inputs)
});
export { components_performancetable_topposition2 as "components.performanceTable.topPosition" }